(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-hat-builder]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const t = JSON.parse(root.querySelector('[data-builder-strings]').textContent);
      const products = JSON.parse(root.querySelector('[data-builder-products]').textContent).filter(p => p.variants.length);
      const screen = root.querySelector('[data-screen]');
      const dialog = root.querySelector('dialog');
      const scrollBody = root.querySelector('.hgb__body');
      const steps = root.querySelector('.hgb__steps');
      const back = root.querySelector('[data-back]');
      const summary = root.querySelector('[data-summary]');
      const order = ['flat', 'trucker', 'dad', 'fitted', 'beanie'];
      const finishes = ['stainless', 'powder', 'silver', 'gold', 'wood', 'black_red', 'charcoal_white', 'charcoal_black', 'copper', 'color'];
      let state = { page: 'style', group: null, product: null, material: null, finish: null };
      let revision = 0;
      const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const photo = (src, alt, cls = '') => src ? `<img class="${cls}" src="${escape(src)}" alt="${escape(alt)}" width="640" height="480" loading="lazy">` : '';
      const imageFor = finish => state.product?.variants.find(v => v.finish === finish)?.image || products.flatMap(p => p.variants).find(v => v.finish === finish && v.image)?.image || '';
      const family = finish => ['stainless', 'powder'].includes(finish) ? 'steel' : finish === 'color' ? 'color' : 'engraved';
      const groupProducts = () => products.filter(p => p.group === state.group);
      const hasMaterial = material => state.product.variants.some(v => family(v.finish) === material && v.available);
      const priceSlot = (kind, value) => `<span class="hgb__price" data-price-kind="${escape(kind)}" data-price-value="${escape(value)}"><span>${escape(t.price_loading)}</span></span>`;
      const formatter = new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency', currency:root.dataset.currency || 'USD', currencyDisplay:'narrowSymbol', minimumFractionDigits:2, maximumFractionDigits:2});
      const priceCandidates = (kind, value) => {
        const hats = kind === 'group' ? products.filter(p => p.group === value) : kind === 'product' ? [products[Number(value)]] : [state.product];
        if (hats.some(p => !p || !p.pricing || p.pricing.status === 'loading')) return {status:'loading'};
        if (hats.some(p => p.pricing.status === 'error')) return {status:'error'};
        const offers = hats.flatMap(p => p.variants.filter(v => (kind !== 'material' || family(v.finish) === value) && (kind !== 'finish' || v.finish === value)).flatMap(v => {
          const live = p.pricing.variants.find(x => String(x.id) === String(v.id));
          if (!live?.available || !Number.isFinite(live.price) || live.price < 0) return [];
          const prices = [{cents:live.price, min:1, max:1}];
          if (p.pricing.volumeEnabled) p.pricing.tiers.forEach(tier => {
            if (Number.isInteger(tier.min) && tier.min > 0 && Number.isInteger(tier.max) && (tier.max === 0 || tier.max >= tier.min) && tier.discount > 0 && tier.discount < 100) prices.push({cents:Math.round(live.price * (1 - tier.discount / 100)),min:tier.min,max:tier.max});
          });
          return prices;
        }));
        offers.sort((a,b) => a.cents - b.cents || a.min - b.min);
        return offers.length ? {status:'ready', ...offers[0]} : {status:'error'};
      };
      function updatePrices() {
        root.querySelectorAll('[data-price-kind]').forEach(el => {
          const offer = priceCandidates(el.dataset.priceKind, el.dataset.priceValue);
          if (offer.status !== 'ready') { el.textContent = offer.status === 'loading' ? t.price_loading : t.price_unavailable; return; }
          const qty = offer.max === 0 ? `${offer.min}+` : offer.max === offer.min ? String(offer.min) : `${offer.min}–${offer.max}`;
          const qualifier = offer.min === 1 && offer.max === 1 ? t.price_single : t.price_quantity.replace('{quantity}', qty);
          el.innerHTML = `<strong>${escape(t.starting_price.replace('{price}', formatter.format(offer.cents / 100) + ' ' + root.dataset.currency))}</strong><small>${escape(qualifier)}</small>`;
        });
      }
      let loadingPrices = false;
      async function loadPrices() {
        if (loadingPrices) return;
        loadingPrices = true;
        const queue = products.filter(p => !p.pricing || p.pricing.status === 'error');
        queue.forEach(p => p.pricing = {status:'loading'});
        const worker = async () => {
          while (queue.length) {
            const product = queue.shift();
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 15000);
            try {
              const url = new URL(product.url, location.origin);
              const preview = new URL(location.href).searchParams.get('preview_theme_id');
              if (preview) url.searchParams.set('preview_theme_id', preview);
              const response = await fetch(url.pathname + url.search, {headers:{Accept:'text/html'},signal:controller.signal});
              if (!response.ok) throw new Error('Pricing unavailable');
              const html = await response.text();
              const element = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hg-builder-pricing]');
              const data = JSON.parse(element?.textContent || '{}');
              if (String(data.productId) !== String(product.id) || data.currency !== root.dataset.currency || !Array.isArray(data.variants) || !Array.isArray(data.tiers)) throw new Error('Pricing mismatch');
              product.pricing = {...data, status:'ready'};
            } catch (error) { product.pricing = {status:'error'}; }
            finally { clearTimeout(timeout); updatePrices(); }
          }
        };
        await Promise.all([worker(),worker(),worker()]);
        loadingPrices = false;
      }
      const card = ({action, value, title, description, image, badge, disabled, extra = '', actionLabel = ''}) => `<button type="button" class="hgb__card" data-action="${action}" data-value="${escape(value)}" ${disabled ? 'disabled' : ''}>${image ? photo(image, title) : ''}${extra}<span class="hgb__card-body">${badge ? `<span class="hgb__tag">${escape(badge)}</span>` : ''}<strong>${escape(title)}</strong>${priceSlot(action, value)}<span class="hgb__description">${escape(description)}</span><span class="hgb__choose">${disabled ? escape(t.unavailable) : escape(actionLabel) + ' →'}</span></span></button>`;
      const heading = key => `<h3 tabindex="-1" class="hgb__title">${escape(t[key + '_title'])}</h3><p class="hgb__subtitle">${escape(t[key + '_intro'])}</p>`;
      function render(focus = true) {
        revision++;
        const phase = { style: 0, model: 1, material: 2, finish: 3, review: 4 }[state.page];
        steps.innerHTML = ['style', 'model', 'material', 'finish', 'review'].map((key, i) => `<li ${i === phase ? 'aria-current="step"' : ''} class="${i < phase ? 'is-done' : ''}"><span>${i + 1}</span>${escape(t[key])}</li>`).join('');
        root.dataset.stage = state.page;
        root.querySelector('[data-stage-count]').textContent = t.step_count.replace('{current}', phase + 1);
        root.querySelector('[data-stage-name]').textContent = t[state.page];
        back.disabled = state.page === 'style';
        root.querySelector('[data-restart]').disabled = state.page === 'style';
        summary.textContent = [state.product?.title || (state.group && t[state.group]), state.material && t[state.material + '_title'], state.finish && t[state.finish]].filter(Boolean).join(' / ');
        if (!products.length) { screen.innerHTML = `<p>${escape(t.empty)}</p>`; return; }
        if (state.page === 'style') {
          screen.innerHTML = heading('style') + `<div class="hgb__grid hgb__grid--styles">${order.filter(g => products.some(p => p.group === g)).map(g => card({action:'group',value:g,title:t[g],description:products.filter(p => p.group === g).map(p => p.title).join(' · '),image:products.find(p => p.group === g).image,badge:products.filter(p => p.group === g).length === 1 ? t.one_model : t.many_models.replace('{count}', products.filter(p => p.group === g).length),actionLabel:t.view_models})).join('')}</div>`;
        } else if (state.page === 'model') {
          screen.innerHTML = heading('model') + `<div class="hgb__grid">${groupProducts().map(p => card({action:'product',value:products.indexOf(p),title:p.title,description:p.description,image:p.image,disabled:!p.variants.some(v => v.available)})).join('')}</div>`;
        } else if (state.page === 'material') {
          screen.innerHTML = heading('material') + `<div class="hgb__grid hgb__grid--materials">${['steel','engraved','color'].map(m => {
            const examples = (m === 'steel' ? ['stainless','powder'] : m === 'color' ? ['color'] : ['silver','gold','wood']).filter(f => state.product.variants.some(v => v.finish === f));
            const extra = `<span class="hgb__examples">${examples.map(f => `<span>${photo(imageFor(f), t[f])}<span>${escape(t[f])}</span></span>`).join('')}</span>`;
            return `<button type="button" class="hgb__card hgb__material-card" data-action="material" data-value="${m}" ${!hasMaterial(m) ? 'disabled' : ''}><span class="hgb__material-heading"><strong>${escape(t[m + '_title'])}</strong><span class="hgb__tag">${escape(t[m === 'steel' ? 'premium' : m === 'engraved' ? 'engraved_tag' : 'flexible'])}</span></span>${extra}<span class="hgb__card-body">${priceSlot('material',m)}<span class="hgb__description">${escape(t[m === 'color' ? 'color_material_desc' : m + '_desc'])}</span><span class="hgb__choose">${escape(!hasMaterial(m) ? t.unavailable : t.choose_material)} →</span></span></button>`;
          }).join('')}</div><p class="hgb__note">${escape(t.example)}</p>`;
        } else if (state.page === 'finish') {
          screen.innerHTML = heading('finish') + `<div class="hgb__grid ${state.material === 'steel' ? 'hgb__grid--two' : ''}">${finishes.filter(f => family(f) === state.material).flatMap(f => {
            const v = state.product.variants.find(v => v.finish === f);
            return v ? [card({action:'finish',value:f,title:t[f],description:t[f + '_desc'],image:imageFor(f),extra:!imageFor(f) ? `<span class="hgb__pending"><span>${escape(t[f])}</span><small>${escape(t.photo_pending)}</small></span>` : '',disabled:!v.available,badge:f === 'stainless' ? t.popular : f === 'powder' ? t.upgrade : f === 'color' ? t.flexible : ''})] : [];
          }).join('')}</div><p class="hgb__note">${escape(t.example)}</p>`;
        } else {
          screen.innerHTML = heading('review') + `<div class="hgb__review">${photo(state.product.image, state.product.title)}<div><span class="hgb__tag">${escape(t.selected)}</span><h4>${escape(state.product.title)}</h4><p>${escape(state.product.description)}</p><div class="hgb__finish-summary">${photo(imageFor(state.finish), t[state.finish])}<div><strong>${escape(t[state.finish])}</strong><p>${escape(t[state.finish + '_desc'])}</p></div></div><p class="hgb__note">${escape(t.example)}</p>${priceSlot('finish', state.finish)}<button type="button" class="hgb__continue" data-action="continue">${escape(t.continue)} →</button><p data-status role="status" aria-live="polite"></p></div></div>`;
        }
        updatePrices();
        if (focus) {
          screen.querySelector('h3')?.focus({preventScroll:true});
          scrollBody.scrollTop = 0;
        }
      }
      async function continueToProduct(button) {
        const currentRevision = revision;
        const p = state.product;
        const variant = p.variants.find(v => v.finish === state.finish);
        const status = screen.querySelector('[data-status]');
        button.disabled = true;
        status.textContent = t.checking;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
          const path = new URL(p.url, location.origin);
          const response = await fetch(path.pathname + '.js', {headers:{Accept:'application/json'},signal:controller.signal});
          if (!response.ok) throw new Error('Unavailable product');
          const data = await response.json();
          if (revision !== currentRevision || !root.isConnected) return;
          const exact = data.variants?.find(v => String(v.id) === String(variant.id));
          if (!exact || !exact.available) { status.textContent = t.changed; button.disabled = false; return; }
          path.searchParams.set('variant', String(exact.id));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) path.searchParams.set('preview_theme_id', preview);
          location.assign(path.pathname + path.search);
        } catch (error) {
          if (revision !== currentRevision || !root.isConnected) return;
          status.textContent = t.error;
          button.textContent = t.retry;
          button.disabled = false;
        } finally { clearTimeout(timer); }
      }
      root.addEventListener('click', event => {
        const target = event.target.closest('[data-action]');
        if (!target || target.disabled) return;
        const value = target.dataset.value;
        switch (target.dataset.action) {
          case 'group':
            state = {page:'model',group:value,product:null,material:null,finish:null};
            break;
          case 'product': state.product = products[Number(value)]; state.page = 'material'; break;
          case 'material': state.material = value; state.finish = null; state.page = 'finish'; break;
          case 'finish': state.finish = value; state.page = 'review'; break;
          case 'continue': continueToProduct(target); return;
          default: return;
        }
        render();
      });
      back.addEventListener('click', () => {
        if (state.page === 'review') { state.page = 'finish'; state.finish = null; }
        else if (state.page === 'finish') { state.page = 'material'; state.material = null; }
        else if (state.page === 'material') { state.page = 'model'; state.product = null; }
        else { state.page = 'style'; state.group = null; }
        render();
      });
      root.querySelector('[data-restart]').addEventListener('click', () => { state = {page:'style',group:null,product:null,material:null,finish:null}; render(); });
      let previousOverflow = '';
      let opener = null;
      const open = trigger => {
        if (dialog.open) return;
        opener = trigger || document.activeElement;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        loadPrices();
        render();
      };
      root.querySelector('[data-launch]').hidden = false;
      root.querySelector('[data-launch]').addEventListener('click', event => open(event.currentTarget));
      root.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        revision++;
        document.body.style.overflow = previousOverflow;
        opener?.focus({preventScroll:true});
      });
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || !root.isConnected) return;
        const url = new URL(link.href, location.href);
        if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#hat-builder') {
          event.preventDefault(); open(link);
        }
      });
      dialog.hidden = false;
      if (location.hash === '#hat-builder') open(root.querySelector('[data-launch]'));
      render(false);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
